export default __webpack_public_path__ + "static/media/boa_icon.dd5b3399.png";